// Pure data/types, safe to import from Client Components — no `next/headers`
// here. `index.ts` (server-only: getLocale/getT) and `client.tsx` (the
// useT/useLocale hooks) both build on this instead of on each other, so
// neither pulls the other's runtime into the wrong bundle.
import { pl } from "./pl";
import { en } from "./en";
import type { Dictionary } from "./dictionary";

export type { Dictionary };
export type Locale = "pl" | "en";

export const LOCALE_COOKIE = "locale";
export const DEFAULT_LOCALE: Locale = "pl";

export const dictionaries: Record<Locale, Dictionary> = { pl, en };

export function isLocale(value: string | undefined | null): value is Locale {
  return value === "pl" || value === "en";
}
